<template>
  <div class="no-wx-client-tip" v-if="show">
    <div class="content">请在微信APP内打开该页面</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    this.show = false && !/MicroMessenger/i.test(navigator.userAgent);
  },
};
</script>

<style lang="scss" scoped>
.no-wx-client-tip {
  z-index: 99999;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba($color: #000000, $alpha: 0.7);
  .content {
    position: absolute;
    top: 5rem;
    bottom: 30rem;
    left: 0;
    right: 0;
    margin: auto;
    width: 90%;
    height: 6rem;
    font-size: 1.2rem;
    background-color: #fff;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    padding: 2rem;
    box-sizing: border-box;
    text-align: center;
    justify-content: center;
  }
}
</style>
